import { CollectionModuleDefinitionVersion } from '../../../collection-modules/domain/collection-module';

export const getCollectionModuleVersionFromQueryParam = (draft_collection_module: string) => {
  const { Draft, Live } = CollectionModuleDefinitionVersion;

  return draft_collection_module === 'true' ? Draft : Live;
};
